import { RootDispatch } from "redux/rootReducer";
import { load, loadFail, loadSuccess } from "./allocationHistoryActions";
import * as request from "utility/request";
import { AllocationHistory } from "types/AllocationHistory";
import { AssetClass } from "types/AssetClass";

const apiUrl = process.env.REACT_APP_API_URL;

export const loadAllocationHistories = (reportControlId: string, reportDate: string) => {
  return async (dispatch: RootDispatch) => {
    dispatch(load("all"));

    try {
      const res = await request.getResponseJson<AllocationHistory[]>(
        `${apiUrl}/api/allocationhistory?reportControlId=${reportControlId}&reportDate=${reportDate}`
      );
      dispatch(loadSuccess("all", res));
    } catch (error) {
      return request.handleFetchError(dispatch, error, loadFail("all", error));
    }
  };
};

export const loadAllocationHistoriesByAssetClass = (
  assetClass: AssetClass,
  reportControlId: string,
  reportDate: string
) => {
  const assetClassString = AssetClass[assetClass] as keyof typeof AssetClass;
  return async (dispatch: RootDispatch) => {
    dispatch(load(assetClassString));

    try {
      const res = await request.getResponseJson<AllocationHistory[]>(
        `${apiUrl}/api/allocationhistory/${assetClass}?reportControlId=${reportControlId}&reportDate=${reportDate}`
      );
      dispatch(loadSuccess(assetClassString, res));
    } catch (error) {
      return request.handleFetchError(dispatch, error, loadFail(assetClassString, error));
    }
  };
};
